type Props = {
  className?: string;
};

export default function Logo({ className = 'h-8 w-auto' }: Props) {
  return (
    <img
      src="/logo.png"
      alt="Nexsol Labs"
      className={className}
      draggable={false}
    />
  );
}
